import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    amountCointainer: {
        display: 'flex',
        alignItems: 'end',
        marginBottom: theme.spacing(2)
    },
    textField: {
        padding: 0,
        marginLeft: theme.spacing(1),
        '& .MuiOutlinedInput-input': {
            padding: 0,
            height: '32px',
            marginLeft: theme.spacing(2)
        }
    },
    buttonsContainer: {
        width: '180px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-between'
    }
}))